import {
    numberFormatter,
    percentageBarFormatter,
    healthFormatter,
    healthColorAlertFormatter,
    healthAlertFormatter,
    integerFormatter,
    redNegativeFormatter,
    removeURIEncode,
    serviceNowButton,
    currentFormatter,
    dateFormatter,
    booleanFormatter,
    moneyFormatter, ServiceNowButton
} from "../../gridFormatters";
import { wtPctAvg } from "../../math";

export const virtualGridDefs = [
    {
        "field": "max_alert",
        "headerName": "Max Alert Level",
        "enableRowGroup": true,
        "cellRenderer": healthFormatter,
        "cellStyle": {
            "textAlign": "center"
        }
    },
    {
        "field": "datacenter_name",
        "headerName": "Data Center"
    },
    {
        "field": "vcenter_name",
        "headerName": "VCenter"
    },
    {
        "field": "current",
        "cellRenderer": currentFormatter,
        "headerName": "Days Old",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellStyle": {
            "textAlign": "center"
        }
    },
    {
        "field": "num_clusters",
        "cellRenderer": integerFormatter,
        "headerName": "Clusters",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "num_esx_hosts",
        "cellRenderer": integerFormatter,
        "headerName": "Hosts",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "num_vms",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "# VM/LPARs",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "num_active_vms",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "Active Vms",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "vm_build_capacity",
        "type": "numericColumn",
        "headerName": "VM Build Capacity",
        "cellRenderer": redNegativeFormatter,
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "total_processors",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "Processors",
        "filter": "agNumberColumnFilter",
        "hide": true,
    },
    {
        "field": "cpu_util_pct",
        "type": "numericColumn",
        "cellRenderer": percentageBarFormatter,
        "headerName": "CPU Util %",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "total_memory",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "Memory",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "mem_util_pct",
        "type": "numericColumn",
        "headerName": "Memory Util %",
        "cellRenderer": percentageBarFormatter,
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "num_data_stores",
        "cellRenderer": integerFormatter,
        "headerName": "Data Stores",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "datastore_allocation",
        "type": "numericColumn",
        "headerName": " Total Data Store Allocation",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
    },
    {
        "field": "datastore_used",
        "type": "numericColumn",
        "headerName": "Used (Data Store)",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "hide": true,
    },
    {
        "field": "disk_util_pct",
        "type": "numericColumn",
        "headerName": "Storage Util %",
        "cellRenderer": percentageBarFormatter,
        "filter": "agNumberColumnFilter",
        "aggFunc": params => wtPctAvg(params, "datastore_used", "datastore_allocation"),
    },
    {
        "field": "num_vm_tools_errors",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "Tool Errors",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "duplicate_vmdk_count",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "Duplicate Vmdk",
        "filter": "agNumberColumnFilter",
    },
    {'field': "firmware", 'headerName': "Firmware",
        "hide": true,},
    {
        "field": "display_name",
        "headerName": "Display Name",
        "hide": true
    },
    {
        "field": "client_id",
        "headerName": "Client Id",
        "hide": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "period_id",
        "headerName": "Period Id",
        "hide": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },

    {
        "field": "device_type_code",
        "headerName": "Device Type Code",
        "hide": true
    },
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "filter": "agDateColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": dateFormatter,
        "hide": true
    },
    {
        "field": "alert_red",
        "cellRenderer": integerFormatter,
        "headerName": "Red Alerts",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "alert_yellow",
        "cellRenderer": integerFormatter,
        "headerName": "Yellow Alerts",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "alert_green",
        "cellRenderer": integerFormatter,
        "headerName": "Green Alerts",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "total_data_centers",
        "cellRenderer": integerFormatter,
        "headerName": "Data Centers",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "total_config_errors",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "Config Errors",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "total_old_hardware",
        "type": "numericColumn",
        "headerName": "Old Hardware",
        "cellRenderer": integerFormatter,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "total_orphaned_data_stores",
        "type": "numericColumn",
        "headerName": "Orphaned",
        "cellRenderer": integerFormatter,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "total_orphaned_data_store_space",
        "type": "numericColumn",
        "headerName": "Orphaned Space",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "hide": true
    },
    {
        "field": "free_space",
        "type": "numericColumn",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "hide": true
    },
]

export const virtualAlertsDefs = [
    {
      field: "id",
        headerName: 'ID'
    },
    {
        "field": "alert",
        "headerName": "Alert"
    },
    {
        "field": "severity",
        "headerName": "Severity",
        "cellRenderer": healthColorAlertFormatter
    },
    {
        "field": "device_name",
        "headerName": "Device Name"
    },
    {
        "field": "current",
        "headerName": "Days Old",
        "filter": "agSetColumnFilter",
        "hide": true,
        "cellRenderer": currentFormatter,
        "cellStyle": {
            "textAlign": "center"
        }
    },
    {
        "field": "category",
        "headerName": "Category",
    },
    {
        "field": "alert_target",
        "headerName": "Alert Target"
    },
    {
        "field": "description",
        "headerName": "Description",
        "cellRenderer": removeURIEncode
    },
    {
        "field": "acknowledged",
        "headerName": "Acknowledged?",
        "cellRenderer": booleanFormatter,
    },
    {
        "field": "incident_id",
        "headerName": "Service Now",
        "cellRenderer": ServiceNowButton
    }
];
export const virtualOrphansVMDKsDefs = [
    {
        "field": "severity",
        "headerName": "Severity",
        "cellRenderer": healthColorAlertFormatter
    },
    {
        "field": "device_name",
        "headerName": "vCenter Name"
    },
    {
        "field": "current",
        "headerName": "Days Old",
        "filter": "agSetColumnFilter",
        "hide": true,
        "cellRenderer": currentFormatter,
        "cellStyle": {
            "textAlign": "center"
        }
    },
    {
        "field": "category",
        "headerName": "Category",
    },
    {
        "field": "alert",
        "headerName": "Alert",
        "cellRenderer": removeURIEncode
    },
    {
        "field": "description",
        "headerName": "Description",
        "cellRenderer": removeURIEncode
    },
    {
        "field": "vm_name",
        "headerName": "VM Name"
    },
    {
        "field": "vmdk",
        "headerName": "VMDK"
    },
    {
        "field": "vmdk_size",
        "headerName": "VMDK Size",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        // comparator: (valueA, valueB) => valueA - valueB,
        "cellRenderer": numberFormatter,
        "aggFunc": "sum"
    },
    {
        "field": "data_store",
        "headerName": "Datastore"
    },
    {
        "field": "acknowledged",
        "headerName": "Acknowledged?",
        "cellRenderer": booleanFormatter,
    },

    {
        "field": "incident_id",
        "headerName": "Service Now",
        "cellRenderer": ServiceNowButton
    }
];
export const vCenterSummaryDefs = [
        {'field': "cluster_name", 'headerName': "Cluster"},
        {'field': "datacenter_name", 'headerName': "Data Center"},
        {
            'field': "total_vms", 'type': "numericColumn", 'cellRenderer': integerFormatter,
            'headerName': "Total VM/LPARs", 'filter': "agNumberColumnFilter",
            'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "total_cpus", 'type': "numericColumn", 'cellRenderer':  numberFormatter,
            'headerName': "Total CPU's", 'filter': "agNumberColumnFilter", 'filterParams': {
                'cellHeight': 20,
                'debounceMs': 1000
            }
        },
        {
            'field': "total_mhz", 'type': "numericColumn", 'headerName': "Total MHz",
            'filter': "agNumberColumnFilter",
            'cellRenderer': numberFormatter,
            'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "avg_cpu_utilization", 'type': "numericColumn",
            'cellRenderer': percentageBarFormatter,
            'headerName': "Avg % CPU Util", 'aggFunc': "avg",
            'filter': "agNumberColumnFilter",
            'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },

        {
            'field': "max_cpu_utilization",
            'cellRenderer': percentageBarFormatter,
            aggFunc: 'max',
            'type': "numericColumn", 'headerName': "Highest % CPU Util", "hide": true
        },

        {
            'field': "avg_ghz_per_cpu", 'type': "numericColumn", 'headerName': "Avg GHz/CPU",
            'cellRenderer': numberFormatter,
            'aggFunc': "avg", 'filter': "agNumberColumnFilter",
            'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "total_memory", 'type': "numericColumn", 'headerName': "Total Memory",
            'cellRenderer': numberFormatter,
            'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "avg_memory_util",
            'cellRenderer': percentageBarFormatter,
            aggFunc: 'avg',
            'type': "numericColumn", 'headerName': "Avg % Memory Util",
            'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "max_memory_util",
            'cellRenderer': percentageBarFormatter,
            'aggFunc': 'max',
            'type': "numericColumn", 'headerName': "Highest % Memory Util",
            'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "total_disk_allocated", 'type': "numericColumn", 'headerName': "Total Disk Allocated",

            'cellRenderer': numberFormatter,'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "total_disk_used", 'type': "numericColumn", 'headerName': "Total Disk Used",
            'cellRenderer': numberFormatter,
            'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "disk_util_pct",
            'cellRenderer': percentageBarFormatter,
            'type': "numericColumn",
            'aggFunc': 'avg',
            'headerName': "% Disk Used",
            'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "total_hosts", 'cellRenderer': integerFormatter, 'type': "numericColumn",
            'headerName': "# of Hosts", 'filter': "agNumberColumnFilter",
            'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "vm_build_capacity", 'cellRenderer': redNegativeFormatter, 'type': "numericColumn",
            'headerName': "VM Build Capacity", 'filter': "agNumberColumnFilter",
            'filterParams': {'cellHeight': 20, 'debounceMs': 1000}
        },
        {
            'field': "device_type_code", 'headerName': "Device Type Code", "hide": true,
            'cellRenderer': 'blankForNullFormatter'
        }

    ]
export const virtualHealthDefs = [
    {
        "field": "device_name",
        "headerName": "Device Name"
    },
    {
        "field": "device_type_code",
        "headerName": "Type",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "enableRowGroup": true
    },
    {
        "field": "current",
        "headerName": "Days Old",
        "filter": "agSetColumnFilter",
        "hide": true,
        "cellRenderer": currentFormatter,
        "cellStyle": {
            "textAlign": "center"
        }
    },
    {
        "field": "config_alert_level_str",
        "headerName": "Configuration & Setup",
        "cellStyle": {
            "textAlign": "center"
        },
        "cellRenderer": healthAlertFormatter,
        "filter": "agSetColumnFilter"
    },
    {
        "field": "balance_alert_level_str",
        "headerName": "Balance",
        "cellStyle": {
            "textAlign": "center"
        },
        "cellRenderer": healthAlertFormatter,
        "filter": "agSetColumnFilter"
    },
    {
        "field": "host_alert_level_str",
        "headerName": "Server Volume Mapping",
        "cellStyle": {
            "textAlign": "center"
        },
        "cellRenderer": healthAlertFormatter,
        "filter": "agSetColumnFilter"
    },
    {
        "field": "general_errors_alert_level_str",
        "headerName": "Errors & Other Alerts",
        "cellStyle": {
            "textAlign": "center"
        },
        "cellRenderer": healthAlertFormatter,
        "filter": "agSetColumnFilter"
    },
    {
        "field": "pool_alert_level_str",
        "headerName": "Storage Layout",
        "cellStyle": {
            "textAlign": "center"
        },
        "cellRenderer": healthAlertFormatter,
        "filter": "agSetColumnFilter"
    },
    {
        "field": "volume_snap_alert_level_str",
        "headerName": "Volumes / Snapshots",
        "cellStyle": {
            "textAlign": "center"
        },
        "cellRenderer": healthAlertFormatter,
        "filter": "agSetColumnFilter"
    }
];

export const virtualClusterPlansDefs = [
    {
        "field": "projectName",
        "headerName": "Project"
    },
    {
        "field": "clusterName",
        "headerName": "Cluster Name"
    },
    {
        "field": "deviceName",
        "headerName": "Device Name"
    },
    {
        "field": "date",
        "headerName": "Month"
    },
    {
        "field": "addedCost",
        "headerName": "Added Cost",
        cellRenderer: moneyFormatter
    },
    {
        "field": "notes",
        "headerName": "Notes"
    },
    {
        "field": "adjustments",
        "headerName": "Changes"
    },
    {
        "field": "changedByUserEmail",
        "headerName": "Made By",
    },
];
